// @ts-nocheck
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import siteMessage from "@insite/client-framework/SiteMessage";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import TextField, { TextFieldPresentationProps } from "@insite/mobius/TextField";
import constants from "@store/constants";
import setFieldValue from "@store/Framework/Store/Greif/Components/RecommendedProductRequestForm/Handlers/SetFieldValue";
import { RecommendedProductRequestFormContext } from "@store/Library/Widgets/RecommendedProductRequest/RecommendedProductRequestForm";
import React, { ChangeEvent, FC, useContext, useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";

const enum fields {
    fieldLabel = "fieldLabel",
    isDisabled = "isDisabled",
    isRequired = "isRequired",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.isDisabled]: boolean;
        [fields.isRequired]: boolean;
    };
}

const mapStateToProps = (state: ApplicationState) => ({
    recommendedPackaging:
        state.greif.components.recommendedProductRequestForm.fieldValues["alternativeShortDescription"],
    location: getLocation(state),
});

const mapDispatchToProps = {
    setFieldValue,
};

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps>;

export interface RecommendedPackagingStyles {
    recommendedPackagingTextField?: TextFieldPresentationProps;
}

export const recommendedPackagingStyles: RecommendedPackagingStyles = {};

const styles = recommendedPackagingStyles;

const RecommendedPackaging: FC<Props> = ({ fields, location, recommendedPackaging, setFieldValue }) => {
    const { isRequired, isDisabled } = fields;
    const recommendedProductRequestFormContext = useContext(RecommendedProductRequestFormContext);
    const [recommendedPackagingErrorMessage, setRecommendedPackagingErrorMessage] = useState("");

    const recommendedPackagingLabel = translate("Product to Consider");

    const queryString = location.search;
    const { recommendedProduct } = parseQueryString<{ recommendedProduct: string }>(queryString.replace("?", ""));

    useEffect(() => {
        recommendedProductRequestFormContext.validators.recommendedPackaging = validateRecommendedPackaging;
        if (typeof recommendedPackaging !== "undefined") {
            validateRecommendedPackaging();
        }
    }, [recommendedPackaging]);

    useEffect(() => {
        recommendedProductRequestFormContext.validators.recommendedPackaging = validateRecommendedPackaging;
    }, [isRequired]);

    useEffect(() => {
        if (recommendedProduct) {
            setFieldValue({ key: "alternativeShortDescription", value: recommendedProduct });
        }
    }, [recommendedProduct]);

    const validateRecommendedPackaging = () => {
        const errorMessage =
            isRequired && !recommendedPackaging
                ? siteMessage("Field_Required", recommendedPackagingLabel).toString()
                : "";
        setRecommendedPackagingErrorMessage(errorMessage);
        return !errorMessage;
    };

    const recommendedPackagingChangeHandler = (event: ChangeEvent<HTMLInputElement>) => {
        setFieldValue({ key: "alternativeShortDescription", value: event.target.value });
    };

    return (
        <TextField
            {...styles.recommendedPackagingTextField}
            label={recommendedPackagingLabel}
            value={recommendedPackaging || ""}
            onChange={recommendedPackagingChangeHandler}
            required={isRequired}
            error={recommendedPackagingErrorMessage}
            disabled={isDisabled}
        />
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(RecommendedPackaging),
    definition: {
        displayName: "Recommended Packaging",
        group: constants.widgetGroup.recommendedProductRequest,
        icon: "input-pipe",
        allowedContexts: [constants.pageType.recommendedProductRequest],
        fieldDefinitions: [
            {
                name: fields.fieldLabel,
                displayName: "Field Label",
                editorTemplate: "TextField",
                defaultValue: "Product to Consider",
                fieldType: "Translatable",
            },
            {
                name: fields.isDisabled,
                displayName: "Disabled?",
                editorTemplate: "CheckboxField",
                defaultValue: true,
                fieldType: "General",
            },
            {
                name: fields.isRequired,
                displayName: "Required Field",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
